import React from 'react';
import { Tooltip } from 'antd';
import type { CountryCode } from 'libphonenumber-js';
import { parsePhone } from '@/utils/parsePhone';

type Props = {
  phoneNumber: string;
  /**
   * default: flag + national number, no link
   * link:    flag + national number wrapped in tel: anchor
   */
  variant?: 'default' | 'link';
  defaultRegion?: CountryCode;
};

export default function PhoneNumberFormat({
  phoneNumber,
  variant = 'default',
  defaultRegion,
}: Props) {
  const parsed = parsePhone(phoneNumber, defaultRegion);

  if (!parsed) {
    return <span>{phoneNumber || '-'}</span>;
  }

  const inner = (
    <Tooltip title={parsed.international}>
      <span style={{ whiteSpace: 'nowrap', cursor: 'default' }}>
        <span style={{ marginRight: 5 }}>{parsed.flag}</span>
        {parsed.national}
      </span>
    </Tooltip>
  );

  if (variant === 'link') {
    return (
      <a href={`tel:${parsed.e164}`} style={{ color: 'inherit' }}>
        {inner}
      </a>
    );
  }

  return inner;
}
